export const cssModulesFlag = 'primer_react_css_modules_staff'
